module.exports = __webpack_public_path__ + "static/media/diya_baliga.d8f2d566.png";